import { createContext, useContext, useMemo, useState } from "react";

const GlobalContext = createContext(undefined);

export function GlobalProvider({ children }) {
  const [highlightColor, setHighlightColor] = useState(
    localStorage.highlightColor || "yellow"
  );
  const [fontSize, setFontSize] = useState(localStorage.fontSize || "md");
  const [darkMode, setDarkMode] = useState(localStorage.theme === "dark");
  const [user, setUser] = useState(null);

  // Wrapper functions to update both state and localStorage
  const updateHighlightColor = (color) => {
    localStorage.highlightColor = color;
    setHighlightColor(color);
  };

  const updateFontSize = (size) => {
    localStorage.fontSize = size;
    setFontSize(size);
  };

  // Memoize so consumers only re-render when a real value changes. Previously a
  // fresh object every render forced the whole subtree to re-render on each
  // highlight (via a now-removed `highlightChanges` counter).
  const value = useMemo(
    () => ({
      highlightColor,
      setHighlightColor: updateHighlightColor,
      fontSize,
      setFontSize: updateFontSize,
      darkMode,
      setDarkMode,
      user,
      setUser,
    }),
    [highlightColor, fontSize, darkMode, user]
  );

  return (
    <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>
  );
}

export function useGlobalContext() {
  const context = useContext(GlobalContext);
  if (context === undefined) {
    throw new Error("useGlobalContext must be used within a GlobalProvider");
  }
  return context;
}
